module.exports = __webpack_public_path__ + "static/img/kcf.905a75f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kcf.png
// module id = 3XT4
// module chunks = 1